export default __webpack_public_path__ + "static/media/up-thumb-hover.d25d49e4.svg";